
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join/[...join-pages]",
      function () {
        return require("private-next-pages/join/[...join-pages].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join/[...join-pages]"])
      });
    }
  